import React from 'react';

import Button from 'common/components/Button';
import { TranslatedMessage } from 'common/components/Intl';
import Modal from 'common/components/modals/Modal';
import * as paths from '../paths';

export default class MembershipLearnMoreModal extends React.Component {
  redirectToMembershipPage = () => {
    window.location.assign(paths.autoShip());
  };

  renderBuyXGetOneCopy(count) {
    const boldedText = (
      <span className="bold">
        <TranslatedMessage
          id={
            'cart.membership_learn_more_modal.sub_head_buy_x_get_one.bolded_text'
          }
          values={{ count }}
        />
      </span>
    );

    return (
      <TranslatedMessage
        id={'cart.membership_learn_more_modal.sub_head_buy_x_get_one.main_body'}
        values={{ boldedText }}
      />
    );
  }

  renderSubscriptionPlanType() {
    const {
      subscribableVariantDiscountRate,
      subscribableVariantFreeFrequency,
    } = this.props;

    if (subscribableVariantDiscountRate) {
      return (
        <TranslatedMessage
          id={'cart.membership_learn_more_modal.sub_head_percentage'}
          values={{
            subscribableVariantDiscountRate:
              subscribableVariantDiscountRate * 100,
          }}
        />
      );
    } else if (subscribableVariantFreeFrequency) {
      return this.renderBuyXGetOneCopy(subscribableVariantFreeFrequency + 1);
    }
  }

  render() {
    const { isOpen } = this.props;
    return (
      <Modal isOpen={isOpen} onRequestClose={this.props.close}>
        <div className="MembershipLearnMoreModal__title Modal__title">
          <TranslatedMessage id={'cart.membership_learn_more_modal.title'} />
          <div className="MembershipLearnMoreModal__subhead text">
            {this.renderSubscriptionPlanType()}
          </div>
        </div>
        <div className="MembershipLearnMoreModal__text Modal__text">
          <TranslatedMessage id={'cart.membership_learn_more_modal.body'} />
        </div>
        <Button onClick={this.redirectToMembershipPage}>
          <TranslatedMessage id={'cart.membership_learn_more_modal.button'} />
        </Button>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/MembershipLearnMoreModal.js